import Nprogress from 'nprogress'
import { useEffect } from 'react'
import { ThemeProvider } from 'ui'
import * as GTM from '~/integrations/gtm'

import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import { Links, Meta, Scripts, ScrollRestoration, useNavigation } from '@remix-run/react'

interface IDocument extends GTM.IGTM {
  children: React.ReactNode
}

export const Document = ({ children, gtmId }: IDocument) => {
  const navigation = useNavigation()
  useEffect(() => {
    if (navigation.state === 'loading' || navigation.state === 'submitting') {
      Nprogress.start()
    } else {
      Nprogress.done()
    }
  }, [navigation.state])

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="referrer" content="no-referrer-when-downgrade" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="facebook-domain-verification" content="86frvrkyj8nvvpf5dmhru4z5t7c1sm" />
        <title>Check Your Student Loan Eligibility | MPOWER Financing</title>
        <meta
          name="description"
          content="See if you're eligible for a student loan from MPOWER Financing. No co-signer, collateral or U.S. credit history needed!"
        />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Earn $100 when a friend refers you to MPOWER" />
        <meta
          property="og:description"
          content="See if you're eligible for a student loan from MPOWER Financing. No co-signer, collateral or U.S. credit history needed!"
        />
        <meta
          property="og:image"
          content="https://app.mpowerfinancing.com/images/refer-and-earn-100-1200X630.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="app.mpowerfinancing.com" />
        <meta name="twitter:title" content="Earn $100 when a friend refers you to MPOWER" />
        <meta
          name="twitter:description"
          content="See if you're eligible for a student loan from MPOWER Financing. No co-signer, collateral or U.S. credit history needed!"
        />
        <meta
          name="twitter:image"
          content="https://app.mpowerfinancing.com/images/refer-and-earn-100-1200X630.jpg"
        />
        <meta name="twitter:image:width" content="1200" />
        <meta name="twitter:image:height" content="630" />
        <Meta />
        <Links />
        <GTM.Head gtmId={gtmId} />
      </head>
      <body>
        <ThemeProvider>{children}</ThemeProvider>
        <GTM.Body gtmId={gtmId} />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}
